import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "ion-container",
  ref: "containerRef"
}
const _hoisted_2 = {
  ref: "canvasRef",
  class: "ion-canvas"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("canvas", _hoisted_2, null, 512), [
      [_vShow, _ctx.isExploding]
    ]),
    _createElementVNode("button", {
      class: "ion-button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
      ref: "buttonRef"
    }, _toDisplayString(_ctx.buttonText), 513)
  ], 512))
}